module.exports = __webpack_public_path__ + "img/women.d47e49eb.svg";